import React from "react";
import $ from "jquery";
import ReactDOM from "react-dom/client";
import "./App.scss";
//import './index.css';
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import './stylecss/scripts.js';
//import "bootstrap/dist/css/bootstrap.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-circular-progressbar/dist/styles.css";
import "@material-design-icons/font";

//import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { ToastContainer } from "react-toastify";
import { store } from "./store";
import { Provider } from "react-redux";
// import "./assets/script";
import { LoaderProvider } from "./Loader";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <LoaderProvider>
        <App />
      </LoaderProvider>
    </Provider>
    <ToastContainer />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
